import type {IGroup, JsonDataResponse} from "~/types/types";
import {GROUP_TYPES_KEY} from "~/types/cached_keys";
import {GROUPTYPE_API} from "~/routes/ari_routes";
import {showErrorToast} from "~/types/helpers";
import {api_header} from "~/types/api_header";

export default async function () {
    const groupTypes = ref<IGroup[]>([])

    const {data: cached } = useNuxtData(GROUP_TYPES_KEY)

    if (cached.value?.data != undefined) {
        groupTypes.value = cached.value.data
    } else {
        const cfg = useRuntimeConfig()

        const {data} = await
            useFetch<JsonDataResponse<IGroup[]>>(GROUPTYPE_API, {
                baseURL: String(useNuxtApp().$apiUrl()),
                headers: api_header(),
                key: GROUP_TYPES_KEY
            })

        if (data.value?.status)
            groupTypes.value = data.value.data
        else
            showErrorToast(data.value?.error)
    }

    return {
        groupTypes
    }
}